'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _knockout = require('@marmalade/validation/lib/knockout');
var _knockout2 = _interopRequireDefault(_knockout);
var _is = require('@marmalade/validation/lib/is');
var _is2 = _interopRequireDefault(_is);
var _validateIf = require('@marmalade/validation/lib/validate-if');
var _validateIf2 = _interopRequireDefault(_validateIf);
var _oneByOne = require('@marmalade/validation/lib/one-by-one');
var _oneByOne2 = _interopRequireDefault(_oneByOne);
var _required = require('@marmalade/validation/lib/required');
var _required2 = _interopRequireDefault(_required);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var isVehicleInsured = function isVehicleInsured(value) {
  if (value === 'N') {
    return 'We’re sorry, this policy only covers you to practise in a car that’s already insured by the car owner.';
  }
};
exports.default = {
  claims: (0, _knockout2.default)(),
  convictions: (0, _knockout2.default)(),
  disallowedOccupations: (0, _knockout2.default)(),
  modified: (0, _required2.default)(),
  modifiedForDisability: (0, _validateIf2.default)(function (_, _ref) {
    var modified = _ref.modified;
    return modified === 'Y';
  }, (0, _oneByOne2.default)((0, _required2.default)(), (0, _is2.default)('Y', function (_ref2) {
    var value = _ref2.value;
    return value ? 'Unfortunately you are unable to proceed if the vehicle has been modified from the manufacturer’s specification.' : '';
  }))),
  vehicleInsured: isVehicleInsured
};